/** Mirrors backend portal-auth.utils for UI routing. */

export type PortalAuthIdentity = {
  role?: string | null;
  createdById?: string | null;
  customRoleId?: string | null;
  tenantProfileId?: string | null;
  accountStatus?: string;
};

export function isLandlordOwner(user: PortalAuthIdentity): boolean {
  return user.role === 'LANDLORD' && !user.createdById;
}

export function isLandlordPortalUser(user: PortalAuthIdentity): boolean {
  if (user.role === 'TENANT' || user.tenantProfileId) return false;
  if (user.role === 'LANDLORD') return true;
  if (user.createdById) return true;
  if (user.role === 'AGENT' || user.role === 'CARETAKER') return true;
  if (user.role === 'ADMIN' && user.createdById) return true;
  if (user.customRoleId) return true;
  return false;
}
